import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import View from "../View/index.js";
import Text from "../Text/index.js";
const SelectOptionGroup = (props) => {
    const { label, children } = props;
    return (_jsxs(View, { attributes: { role: "group" }, gap: 1, children: [_jsx(View, { paddingInline: 3, paddingTop: 3, children: _jsx(Text, { variant: "caption-1", color: "neutral-faded", children: label }) }), _jsx(View.Item, { children: children })] }));
};
SelectOptionGroup.displayName = "Select.OptionGroup";
export default SelectOptionGroup;
